var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("el-date-picker", {
                staticClass: "day-item",
                attrs: {
                  appendToBody: false,
                  clearable: false,
                  format: "yyyy-MM",
                  "value-format": "yyyy-MM",
                  type: "month",
                  "unlink-panels": "",
                },
                on: { change: _vm.handlerDateChange },
                model: {
                  value: _vm.params.dtMonth,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "dtMonth", $$v)
                  },
                  expression: "params.dtMonth",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        _vm._l(_vm.cardOptions, function (item, index) {
          return _c(
            "el-col",
            {
              key: index,
              staticClass: "card-item mt-18",
              attrs: { lg: 6, md: 12, sm: 12, xl: 6 },
            },
            [
              _c(
                "dataCard",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading.cardLoading,
                      expression: "loading.cardLoading",
                    },
                  ],
                  attrs: { item: item, active: 0 },
                },
                [
                  index === 1
                    ? _c(
                        "div",
                        {
                          staticClass: "icon-slot",
                          attrs: { slot: "icon" },
                          slot: "icon",
                        },
                        [
                          _c("div", { staticClass: "slot-line" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("customer::profits::新客数"))
                              ),
                            ]),
                            _c("span", [_vm._v(_vm._s(_vm.newCustomerNum))]),
                          ]),
                          _c("div", { staticClass: "slot-line" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("customer::profits::复购客数"))
                              ),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.reorderCustomerNum)),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("el-col", { staticClass: "mt-18", attrs: { md: 24, lg: 12 } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.cardReportLoading,
                    expression: "loading.cardReportLoading",
                  },
                ],
                staticClass: "avg-container",
                style: "height: " + _vm.reportHeight + ";",
              },
              [
                _c("cardIconReport", {
                  attrs: { cardData: _vm.cardReportOptions },
                }),
                _c("div", { staticClass: "avg-wrap" }, [
                  _c("div", { staticClass: "avg-content" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("customer::profits::lostCustomer", {
                            lossCustomerNum: _vm.lossCustomerNum,
                          })
                        )
                      ),
                    ]),
                    _c("a", { on: { click: _vm.toCustomer } }, [
                      _vm._v(
                        _vm._s(_vm.$t("customer::profits::checkCustomer"))
                      ),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "el-col",
            { attrs: { md: 24, lg: 12 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.customerAttrLoading,
                    expression: "loading.customerAttrLoading",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.customerAttr },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { md: 24, lg: 12 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.newCustomerLoading,
                    expression: "loading.newCustomerLoading",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.newCustomer },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { md: 24, lg: 12 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.customerReorderLoading,
                    expression: "loading.customerReorderLoading",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.customerReorder },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }